"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _constants = require("../Icon/constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function SelectButton(_ref) {
  var ariaControlName = _ref.ariaControlName,
      opened = _ref.opened,
      errorInTooltip = _ref.errorInTooltip,
      error = _ref.error,
      checked = _ref.checked,
      className = _ref.className,
      mini = _ref.mini,
      boxed = _ref.boxed,
      selectedOptions = _ref.selectedOptions,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onKeyPress = _ref.onKeyPress;
  var selected;
  var count;

  if (selectedOptions) {
    if (typeof selectedOptions === 'string') {
      selected = selectedOptions;
    } else if (selectedOptions.length < 2) {
      var _selectedOptions = _slicedToArray(selectedOptions, 1);

      selected = _selectedOptions[0];
    } else {
      selected = selectedOptions.join(', ');
      count = selectedOptions.length;
    }
  } else selected = 'Select';

  var selectButtonClassName = (0, _utils.getClassNames)('select__button', className, {
    select__button_tooltiped: errorInTooltip
  }, {
    select__button_mini: mini
  }, {
    select__button_boxed: boxed
  }, {
    select__button_checked: checked
  });
  return /*#__PURE__*/_react.default.createElement("button", {
    className: selectButtonClassName,
    type: "button",
    "aria-controls": ariaControlName,
    "aria-expanded": opened,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick,
    onKeyPress: onKeyPress
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "selected__values"
  }, selected), count && /*#__PURE__*/_react.default.createElement("span", {
    className: "selected__count"
  }, count), errorInTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: error
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: _constants.ICON_TYPE_ERROR,
    className: "anticon__error"
  })), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: _constants.ICON_TYPE_DROPDOWN,
    className: "anticon__arrow"
  }));
}

SelectButton.propTypes = {
  ariaControlName: _propTypes.default.string,
  className: _propTypes.default.string,
  error: _propTypes.default.string,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  opened: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  mini: _propTypes.default.bool,
  boxed: _propTypes.default.bool,
  errorInTooltip: _propTypes.default.bool,
  selectedOptions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string])
};
SelectButton.defaultProps = {
  ariaControlName: null,
  className: '',
  error: null,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onKeyPress: function onKeyPress() {},
  opened: false,
  checked: false,
  mini: false,
  boxed: false,
  errorInTooltip: false,
  selectedOptions: null
};
var _default = SelectButton;
exports.default = _default;